import styled from "styled-components";

export const Loader = styled.div`
  color: grey;
  font-size: 14px;
`;
